(function (sculpteo) {
  "use strict";

  var PrintController = sculpteo.PrintController;

  var PrintController3D = (sculpteo.PrintController3D = function (
    design,
    materials,
    listOfUrls,
    optionsHollowing
  ) {
    this.controllerType = "3D";

    // WD-872
    if (!design.material && design.default_material_slug) {
      var new_default_material;
      for (var key in materials) {
        var material = materials[key];
        if (material.slug === design.default_material_slug) {
          new_default_material = material;
        }
      }
      design.material = new_default_material;
      design.default_material = new_default_material;
    }
    // --------

    PrintController.call(this, design, materials, listOfUrls, optionsHollowing);

    this.views.viewer = new sculpteo.PrintViewerView(this, this.design);
    this.views.toolbar = new sculpteo.PrintToolbarView(this, this.design);
    this.views.modalToolsView = new sculpteo.PrintModalToolsView(
      this,
      this.design
    );
    this.views.modalReviewView = new sculpteo.PrintModalReviewView(
      this,
      this.design,
      listOfUrls.printIframePageUrl
    );
    this.views.modalGiveUsACallView = new sculpteo.PrintModalGiveUsACallView(
      this,
      this.design
    );
    this.views.modalQuote = new sculpteo.PrintModalQuote(this, this.design);
    this.views.soliditycheck = new sculpteo.PrintSolidityCheckView(
      this,
      this.design,
      this.views.viewer.viewerUI
    );
    this.views.partOrientation = new sculpteo.PrintPartOrientationView(
      this,
      this.views.viewer,
      this.design,
      listOfUrls.axisModelUrl
    );
    this.views.batchControl = new sculpteo.PrintBatchControlView(
      this,
      this.views.viewer,
      this.design
    );
    this.views.hollowing = new sculpteo.PrintHollowingView(
      this,
      this.views.viewer,
      this.design,
      this.material,
      optionsHollowing
    );
    this.views.thickening = new sculpteo.PrintThickeningView(
      this,
      this.design,
      this.views.viewer.viewerUI,
      optionsHollowing
    );
    this.views.slicer = new sculpteo.PrintSlicerView(
      this,
      this.design,
      this.views.viewer.viewerUI
    );
    this.views.materials = new sculpteo.PrintMaterialsView(this, this.design);
    this.views.howto = new sculpteo.PrintHowTo(
      this,
      this.design,
      this.views.viewer.viewerUI
    );
    this.views.series = new sculpteo.PrintSeriesView(this, this.design);
    this.views.marketplaceThumbnail =
      new sculpteo.PrintMarketplaceThumbnailView(this, this.design);
    this.viewerUI = this.views.viewer.viewerUI;

    this.setLoading(true);

    // Will initialize print_op if necessary. And needed for EVERYTHING.
    this.design.fetch_operation(true, false).then(
      function (data) {
        if (window.isStaff && data.uuid) {
          this.views.informations.setModelEditInfo(data.uuid);
        }
        //check for thickening if it is already set
        this.views.thickening.has_thickening();

        //check for hollowing if it is already set
        this.views.hollowing.has_hollowing();

        //check for part orientation if there is already an orientation set
        this.views.partOrientation.has_orientation();

        this.views.batchControl.updateBatchControl().done(
          function () {
            // If favourite 3D material is in the material map and if it is not in the staff only material
            // and the version of the design must be 1, mean that the design has NOT been added to a cart
            // and the age of the design must be 0, means that the design has not been already modified.
            var favouriteMaterial = this.design.favourite_3d_material;
            var materialConfig = sculpteo.MaterialConfiguration;
            var config;

            if (
              materialConfig.materialMap.hasOwnProperty(favouriteMaterial) &&
              Object.keys(materialConfig.materialMap).indexOf(
                favouriteMaterial
              ) !== -1 &&
              !this.design.has_template &&
              this.design.age == 0
            ) {
              config =
                this.materials.getMaterialPaintingFinishFromMap(
                  favouriteMaterial
                );
              this.updateMaterial(
                config.material,
                config.finish,
                config.painting,
                undefined,
                config.options,
                config.color
              );
            } else {
              this.updatePriceForSelectedMaterial();
            }

            this.views.series.reload();
            this.updateMaterialList();
          }.bind(this)
        );
      }.bind(this)
    );

    //avoid to click on tool before the viewer is ready;
    this.viewerUI.viewer.bind(
      "init",
      function () {
        this.updateToolsAvailability();
      }.bind(this)
    );

    // update fast mode visibility based on current currency
    this.views.price.toggleModeVisibility(this.design.order.currency);

    // Handle details price and delays update
    $(document).on(
      "click",
      ".PrintDetailsView button",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $form = $(".PrintDetailsForm");
        // Set submitted to 1 so the form data is sent with the price request
        $form.find("input[name='submitted']").val("1");
        const colorCode = $form.find("input[name='custom_color_code']").val();
        const colorDisplay = $form
          .find("input[name='custom_color_display']")
          .val();
        if (!colorCode) {
          $form.find("input[name='custom_color_code']").next(".error").show();
          return;
        }
        if (!colorDisplay) {
          $form
            .find("input[name='custom_color_display']")
            .next(".error")
            .show();
          return;
        }
        this.updatePriceForSelectedMaterial();
        this.views.series.reload();
      }.bind(this)
    );
    $(document).on(
      "change",
      ".PrintDetailsForm input[name='custom_color_code']",
      function (e) {
        const query = e.target.value;
        // query is 'RAL 1021', 'RAL1021' or '1021'
        const ralMatch = query.match(/^(RAL\s*)?(\d{4})$/i);
        let hex = "";
        if (ralMatch) {
          hex = RAL_CODES[ralMatch[2]];
        }

        const colorInput = $(
          ".PrintDetailsForm input[name='custom_color_display']"
        );
        if (hex) {
          colorInput.val(hex);
          colorInput.next(".error").hide();
        } else {
          colorInput.val("");
          colorInput.next(".error").show();
        }
        $(e.target).next(".error").hide();
      }.bind(this)
    );
    $(document).on(
      "change",
      ".PrintDetailsForm input[name='custom_color_display']",
      function (e) {
        $(e.target).next(".error").hide();
      }.bind(this)
    );
  });

  PrintController3D.prototype = Object.create(PrintController.prototype);

  /**
   * Extends base PrintController.prototype.updateCurrency
   */
  PrintController3D.prototype.updateCurrency = function (currency, symbol) {
    PrintController.prototype.updateCurrency.call(this, currency, symbol);

    this.views.series.currencyChanged();
  };

  PrintController.prototype.updatePriceForSelectedMaterial = function () {
    var deferred = $.Deferred();

    //if the model is NOT orderable we do not update the price
    if (this.design.is_orderable == false) {
      return deferred;
    }

    //show overlay message
    this.overlayNotify(
      sculpteo.PrintOverlayNotification.TYPE.UPDATE,
      gettext("Updating prices and delays"),
      false
    );

    this.setLoading(true);
    this.materials
      .computePricesAndDelays(true, null, null, true)
      .done(
        function () {
          var priceData = this.materials.getPricesForMaterial(
            this.design.material
          );
          //we set error/warnings to null before to check for error/warnings
          this.error = null;
          this.warnings = null;

          // clears all notification notifications
          this.views.notification.clear();

          //if priceData get error we set this.error with this error (id, text and data)
          //and call nofitication to show the error
          //same with the warning except that it might have 1 or more, so we need a list

          //priceData.error is the old way to get the error
          //priceData.error_info is the new way with the new print page
          //it hold more infos like an ID, the text and data if there is data

          // When generic_purpose is set to false (disabled material), we don't have anything. So we need to display the error
          if (!priceData) {
            priceData = {};
            priceData.error = gettext("This material is currently unavailable");
            priceData.error_info = {
              ID: "material_not_available",
              data: "", // FIXME: should be priceData.error
              text: "",
            };
          }

          //specific case when there is no printers available for that design ( might be the scale that is too big for the printer)
          //or just no printer available at that moment for the selected material
          this.parseDeliveryErrors(priceData, this.design);

          // if the design has been deleted we show an error and no price.
          //we cannot add to cart !!!
          //ticket: #5336
          //this.design.is_removed is set on design/print/index.html line 124
          if (this.design.is_removed) {
            priceData.error = this.design.is_removed;
            //simulate how the error works in gallery/models.py  line:3256
            priceData.error_info = {
              ID: "is_removed",
              data: priceData.error,
              text: "",
            };
          }

          this.managePriceError(priceData);

          //update prices and delays
          //+ updates informations view
          this.views.price.updatePrices(priceData);

          // staff only
          if (window.isStaff) {
            this.views.informations.updateInformations(priceData);
          }

          //if series is enabled, update his price
          if (this.design.series.enabled) {
            this.views.viewer.viewerUI.series.view = false;
            this.views.viewer.viewerUI.update_series(priceData);

            this.views.batchControl.updateView();
          }

          if (this.currentTool == sculpteo.PrintToolsView.TOOLS.HOLLOWING) {
            this.views.series.reload();
          }

          // update hollowing to check if the message should be shown
          this.views.hollowing.toggleOptimizeMessageForHollowing(
            PriceDataUtils.getUnitPrice(
              priceData,
              this.design.order.production_mode || "standard_mode"
            ),
            this.views.price.prices.density
          );

          //update scale error to show the user what he have to do to remove the error
          this.views.settings.updateScaleError();

          //show
          if (this.currentTool == sculpteo.PrintToolsView.TOOLS.DASHBOARD) {
            this.setLoading(false);
          } else {
            this.views.price.enabled(true);
          }

          // display warning message if the current front slug is in the staff combos
          if (window.isStaff) {
            var currentFrontSlug = this.materials.getCurrentMaterialMap();
            if (
              window.materialOptionMapGroup[currentFrontSlug].includes(
                sculpteo.constants.MATERIAL_OPTION_COMBO_GROUPS.STAFF_COMBOS
              )
            ) {
              this.notify(
                "warn",
                sculpteo.WARNING.MATERIAL_IS_STAFF_ONLY,
                false
              );
            }
          }

          deferred.resolve();
        }.bind(this)
      )
      .error(function (e) {
        console.warn("computePricesAndDelays failed", e);
        deferred.reject();
      })
      .always(
        function () {
          this.setLoading(false);
        }.bind(this)
      );

    return deferred;
  };

  PrintController3D.prototype.toggleSolidityCheck = function (enabled) {
    this.views.soliditycheck.toggleSolidityCheck(enabled);
  };

  PrintController3D.prototype.toggleCutaway = function (enabled) {
    this.views.viewer.toggleCutaway(enabled);
  };

  PrintController3D.prototype.toggleWireframe = function (enabled) {
    this.views.viewer.toggleWireframe(enabled);
  };

  PrintController3D.prototype.toggleResetModelPosition = function () {
    if (this.currentTool == sculpteo.PrintToolsView.TOOLS.ORIENTATION) {
      this.views.partOrientation.defaultPosition();
    } else {
      this.views.viewer.resetModelPosition();
    }
  };

  PrintController3D.prototype.managePriceError = function (price) {
    if (price.error) {
      this.error = price.error_info;
      if (this.error.ID == "get_a_quote" || this.error.ID == "min_quantity")
        return;
      else
        this.notify("error", price.error_info.ID, false, price.error_info.data);
    }

    if (price.warnings) {
      this.warnings = price.warnings_list_info;
      price.warnings_list_info.forEach(
        function (warn) {
          this.notify("warn", warn.ID, false, warn.data);
        }.bind(this)
      );
    }
  };

  /**
   * show the help modal of the current tool
   *
   * @public
   */
  PrintController3D.prototype.toggleModalTool = function (forceShowModal) {
    this.views.modalToolsView.showModal(forceShowModal);
  };

  /**
   * show the review modal
   *
   * @public
   */
  PrintController3D.prototype.toggleModalReview = function () {
    this.views.modalReviewView.showModal();
  };

  /**
   * show the give us a call modal if the total is above a threshold
   *
   * @public
   */
  PrintController3D.prototype.toggleModalGiveUsACall = function (totalPrice) {
    this.views.modalGiveUsACallView.activeModal(totalPrice);
  };

  /**
   * show the give quote modal
   *
   * @public
   */
  PrintController3D.prototype.showModalQuote = function (quantity_requested) {
    this.views.modalQuote.showModal(quantity_requested);
  };

  /**
   * show the tour modal
   *
   * @public
   */
  PrintController3D.prototype.toggleTour = function () {
    //force the start of the tour
    this.views.howto.start(true);
  };

  /**
   * show the message for new user
   *
   * @public
   */
  PrintController3D.prototype.showHelpMessage = function () {
    //force the start of the tour
    this.views.toolbar.showHelpMessage();
  };

  /**
   * hide the message for new user
   *
   * @public
   */
  PrintController3D.prototype.hideHelpMessage = function () {
    //force the start of the tour
    this.views.toolbar.hideHelpMessage();
  };

  /**
   * update the viewer with a bg image or 3D model
   *
   * @public
   */
  PrintController3D.prototype.updateViewerBG = function (options) {
    this.views.viewer.viewerUI.viewer_update(options);
  };

  /**
   * update the viewer with current material
   *
   * @public
   */
  PrintController3D.prototype.updateViewerMaterial = function () {
    this.views.viewer.viewerUI.viewer_update(
      this.design.material.encoded(
        this.design.size,
        this.design.finish,
        this.design.painting,
        this.design,
        this.design.order.color
      )
    );
  };

  // The process a vacuum casting resin belongs to, see
  // docs/product/vacuum_casting.md. Matched against the process the selected
  // material sits in and not against the front slug, so that a process whose
  // slug happens to contain this one could never pass for it.
  var VACUUM_CASTING_PROCESS = "vacuum_casting";
  // The option that is the painted finish of the two resins sold painted, the
  // other sixteen being through-dyed only. What the colour asked for below is
  // then a paint rather than a dye mixed in while the parts are cast.
  var VACUUM_CASTING_PAINTING = "painting";

  // TODO: move this elsewhere
  PrintController3D.prototype.getDetailsForm = function (design) {
    if (
      design.material &&
      this.materials.getGroupByProductSlug(design.material.slug) ===
        VACUUM_CASTING_PROCESS
    ) {
      // A vacuum casting line is three: the master model, the moulds and the
      // cast parts. The quantity of parts is the ordinary one of the print
      // page; how many moulds to cast them in is the sales rep's call, since a
      // mould casts 10 to 25 parts and sometimes several at a time, so it is
      // asked for here and travels to the cart as a detail of the part.
      //
      // And the colour the parts are made in, which is not the colour of the
      // product: the colour in a resin's name is what the raw material looks
      // like, and what the customer buys is a part dyed while it is cast -- or
      // painted, on the two resins sold painted, which is what the label below
      // switches on. Free text because there is no paint range for these
      // resins yet, and optional because the colour is settled during the
      // pre-sales exchange and may not be known yet.
      //
      // No "submitted" input and no button on purpose: neither field changes a
      // price -- the staff quote a mould by hand during the pre-sales exchange
      // -- and the price requests only send this form when it carries a
      // submitted input (see
      // PrintMaterialCollection.computePricesAndDelays), so this one reaches
      // the add to cart alone.
      const painted = design.painting === VACUUM_CASTING_PAINTING;
      return `
        <h3 class="settings-title"><span>${gettext(
          "Vacuum casting"
        )}</span></h3>
				<form class="PrintDetailsForm" style="display: flex;flex-direction: column;align-items: start;">
					<label title="${gettext(
            "One mold casts 10 to 25 parts, sometimes several at a time"
          )}">
						${gettext("Number of molds")}
						<input type="number" name="vacuum_casting_molds" min="1" max="99" step="1" value="1">
					</label>
					<label title="${
            painted
              ? gettext("The color the cast parts are painted in")
              : gettext(
                  "The color the cast parts are dyed in, mixed in while they are cast"
                )
          }">
						${painted ? gettext("Paint color") : gettext("Through-dyed color")}
						<input name="vacuum_casting_color" maxlength="64" placeholder="${gettext(
              "RAL code / Name"
            )}">
					</label>
          <input type="hidden" name="vacuum_casting_form" value="vacuum_casting_form">
				</form>
			`;
    }
    if (design.painting === "painting_custom_color") {
      const $form = `
        <h3 class="settings-title"><span>${gettext(
          "Painting custom color"
        )}</span></h3>
				<form class="PrintDetailsForm" style="display: flex;flex-direction: column;align-items: start;">
					<label title="${gettext("Color to help the production team visualise")}">
						${gettext("Display color")}
						<input type="color" name="custom_color_display" value="#3e8ddd">
            <span class="error" style="display: none">${gettext(
              "Please select a color"
            )}</span>
					</label>
					<label>
						${gettext("Color")}
						<input name="custom_color_code" placeholder="${gettext("RAL code / Name")}">
            <span class="error" style="display: none">${gettext(
              "Please enter a valid RAL code or color name"
            )}</span>
					</label>
					<label>
						${gettext("Matte")}
						<input type="radio" name="custom_color_finish" value="matte" checked>
					</label>
					<label>
						${gettext("Satin")}
						<input type="radio" name="custom_color_finish" value="satin">
					</label>
					<label>
						${gettext("Operational configuration")}
						<select name="custom_color_operation">
							<option value="light_coat">${gettext("Light coat of paint")}</option>
							<option value="primer_one_side">${gettext("Primer + paint (1 side)")}</option>
							<option value="primer_two_side">${gettext("Primer + paint (2 sides)")}</option>
							<option value="primer_sanding_one_side">${gettext(
                "Primer + sanding + paint (1 side)"
              )}</option>
							<option value="primer_sanding_two_side">${gettext(
                "Primer + sanding + paint (2 sides)"
              )}</option>
							<option value="flexible_coating">${gettext("Flexible coating")}</option>
							<option value="flexible_coating_smoothing">${gettext(
                "Flexible coating + smoothing"
              )}</option>
						</select>
					</label>
          <input type="hidden" name="custom_color_form" value="custom_color_form">
          <input type="hidden" name="submitted" value="0">
					<button class="btn" style="margin-top: 5px;">${gettext(
            "Update price and delays"
          )}</button>
				</form>
			`;

      return $form;
    }
    return null;
  };

  PrintController3D.prototype.updateDetails = function () {
    const $form = this.getDetailsForm(this.design);
    const $view = $(".PrintDetailsView");
    if ($form) {
      $view.html($form);
      $view.removeClass("hidden");
    } else {
      $view.addClass("hidden");
      $view.html("");
    }
  };

  PrintController3D.prototype.updateProductionMode = function (
    production_mode
  ) {
    if (production_mode == this.design.order.production_mode) {
      console.warn(
        "PrintController3D.prototype.updateProductionMode nothing changed mode=" +
          production_mode
      );
      return;
    }
    console.log(
      "PrintController3D.prototype.updateProductionMode mode=",
      production_mode
    );

    // TODO: ensure the value is valid
    this.design.order.production_mode = production_mode;

    this.views.series.productionModeChanged();
  };

  /**
   * Updates order quantity
   *
   * @public
   * @param {number} quantity
   * @todo: maybe chain batchControl & updatePrice to prevent multiple call or weird issues
   */
  PrintController3D.prototype.updateQuantity = function (quantity) {
    this.setLoading(true);

    var _this = this;

    this.design
      .update_print_op(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        this.design.finish,
        this.design.painting,
        this.design.options,
        quantity
      )
      .then(function () {
        _this.design.order.quantity = quantity;

        //we need to call batchcontrol first
        //if we are in batch, then we update the job in batchcontrol.updateBatchControl
        //Then we call updatePriceForSelectedMaterial
        //otherwise if we're not in batch the function updatebatchControl will resolve the promise directly
        //then we call updatePriceForSelectedMaterial
        _this.views.batchControl.updateBatchControl().done(function () {
          _this.updatePriceForSelectedMaterial().done(function () {
            _this.setLoading(false);
            _this.views.series.quantityChanged();
          });

          _this.updateMaterialList();
        });
      })
      .fail(function (e) {
        console.warn("update_print_op failed", e);
      })
      .always(function () {
        _this.setLoading(false);
      });
  };

  /**
   * Updates unit
   *
   * @public
   * @param {string} unit
   */
  PrintController3D.prototype.updateUnit = function (unit) {
    this.setLoading(true);

    this.design
      .update_print_op(
        undefined,
        unit,
        undefined,
        undefined,
        undefined,
        undefined,
        this.design.order.finish,
        this.design.order.painting,
        this.design.order.options,
        undefined
      )
      .then(
        function () {
          this.views.thickening.unitUpdated().then(
            function () {
              //we need to call batchcontrol first
              //if we are in batch, then we update the job in batchcontrol.updateBatchControl
              //Then we call updatePriceForSelectedMaterial
              //otherwise if we're not in batch the function updatebatchControl will resolve the promise directly
              //then we call updatePriceForSelectedMaterial
              this.views.batchControl.updateBatchControl().done(
                function () {
                  this.updatePriceForSelectedMaterial().then(
                    function () {
                      //we need to know when the unit is updated
                      this.views.hollowing.unitUpdated();
                    }.bind(this)
                  );
                }.bind(this)
              );

              this.updateMaterialList();

              this.views.soliditycheck.scaleUpdated();

              this.views.series.unitChanged(); // TODO: move that up in the callback ?
            }.bind(this)
          ); // FIXME: promises aren't properly chained
        }.bind(this)
      )
      .fail(
        function (e) {
          console.warn("update_print_op failed", e);
        }.bind(this)
      )
      .always(
        function () {
          this.setLoading(false);
        }.bind(this)
      );
  };

  /**
   * Updates scale
   *
   * @public
   * @param {float} scale
   */
  PrintController3D.prototype.updateScale = function (scale) {
    this.setLoading(true);

    this.design
      .update_print_op(
        scale,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        this.design.order.finish,
        this.design.order.painting,
        this.design.order.options,
        undefined
      )
      .then(
        function () {
          // I don't know why, but putting scaleUpdated in a then and the rest in another doesn't work...
          this.views.thickening.scaleUpdated().then(
            function () {
              this.design.size.userScale = scale;
              this.views.settings.updateScale();

              //we need to call batchcontrol first
              //if we are in batch, then we update the job in batchcontrol.updateBatchControl
              //Then we call updatePriceForSelectedMaterial
              //otherwise if we're not in batch the function updatebatchControl will resolve the promise directly
              //then we call updatePriceForSelectedMaterial
              this.views.batchControl.updateBatchControl().done(
                function () {
                  this.updatePriceForSelectedMaterial().then(
                    function () {
                      this.views.hollowing.scaleUpdated();
                    }.bind(this)
                  );
                }.bind(this)
              );
              this.updateMaterialList();
              this.views.soliditycheck.scaleUpdated();
              this.views.series.scaleChanged(); // TODO: we should probably just listen to updatePrice / pricechanged like priceview
            }.bind(this)
          ); // TODO: check promises chaining
        }.bind(this)
      )
      .fail(
        function (e) {
          console.warn("update_print_op failed", e);
        }.bind(this)
      )
      .always(
        function () {
          this.setLoading(false);
        }.bind(this)
      );
  };

  /**
   * Updates printing material, finish and painting.
   * - Update printing operation
   * - Update material selectors
   * - Update prices and delays
   * - Update viewer (magic, i dindn't to anything to make it work)
   *
   * @param {Material} material
   * @param {string} finish
   * @param {string} painting
   * @param {string} origin
   * @param {Array} options
   * @param {string} color - option key of the color, for the materials that are
   *   sold in several ones. Ex: 'color_black'
   *
   * @todo viewer materials for paintings
   * @todo going back from painted option in plastics doesn't seems to update things
   */
  PrintController3D.prototype.updateMaterial = function (
    material,
    finish,
    painting,
    origin,
    options,
    color
  ) {
    this.setLoading(true);

    var update = this.design
      .update_print_op(
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        material,
        finish,
        painting,
        options,
        undefined,
        color
      )
      .then(
        function () {
          this.views.thickening.materialUpdated().then(
            function () {
              this.design.material = material;
              this.design.finish = finish;
              this.design.painting = painting;
              this.design.color = color;
              this.design.order.finish = finish;
              this.design.order.painting = painting;
              this.design.order.color = color;
              this.design.order.options = options;
              this.design.options = options;
              this.views.settings.updateSelectors();
              this.views.materials.updateSelectors();
              this.views.soliditycheck.solidityUpdateThresholds();
              this.updateDetails();

              //we need to call batchcontrol first
              //if we are in batch, then we update the job in batchcontrol.updateBatchControl
              //Then we call updatePriceForSelectedMaterial
              //otherwise if we're not in batch the function updatebatchControl will resolve the promise directly
              //then we call updatePriceForSelectedMaterial
              this.views.batchControl.updateBatchControl().done(
                function () {
                  this.updatePriceForSelectedMaterial().then(
                    function () {
                      this.views.hollowing.materialUpdated();
                    }.bind(this)
                  );

                  // this.views.price.materialChanged();
                  this.views.series.materialChanged();
                }.bind(this)
              );

              try {
                window.tagCommander.sendTag(null, "print_material_change", {
                  product_category: this.materials
                    .getCurrentMaterialMap()
                    .split(",")[0],
                  product_material: material.slug,
                  product_finish: finish || "",
                  product_painting: painting || "",
                  clic_origin: origin || "print_new",
                });
              } catch (e) {}

              this.updateToolsAvailability();

              // Update viewer
              this.updateViewerMaterial();
            }.bind(this)
          );
        }.bind(this)
      )
      .fail(
        function (e) {
          console.warn("update_print_op failed", e);
        }.bind(this)
      )
      .always(
        function () {
          this.setLoading(false);
        }.bind(this)
      );
  };

  /**
   * Update model orientation
   * Will update prices if packing is active.
   *
   * @param {bool} enabled
   * @param {object} orientation
   * @todo handle material change => disable fixed orientation if the new material is not elligible
   */
  PrintController3D.prototype.updateOrientation = function (
    enabled,
    orientation
  ) {
    var deferred = $.Deferred();

    // if (this.design.series.enabled) {
    // 	this.views.partOrientation.toggleThumbnails(false);
    // }

    this.views.tools.setEnabled(
      sculpteo.PrintToolsView.TOOLS.ORIENTATION,
      enabled
    );
    this.design
      .update_print_op(
        undefined,
        undefined,
        undefined,
        undefined,
        orientation,
        undefined,
        this.design.finish,
        this.design.painting,
        this.design.options,
        undefined
      )
      .then(
        function (data) {
          // Change orientation status for cart
          this.design.order.fixed_orientation = enabled ? 1 : 0;

          // Update price if series is enabled (because it changes the batch height, thus the price)
          if (this.design.series.enabled) {
            this.updatePriceForSelectedMaterial();
            this.views.series.orientationChanged();
            //need this to update the series after a new part orientation
            this.viewerUI.topics["operation-updated"](data);
          }

          deferred.resolve();
        }.bind(this)
      );

    return deferred;
  };

  /**
   * Callback for thickening update
   * As thickening changes the size of the model, we update the displayed size and
   * compute all prices again.
   * @param {bool} active
   * @param {bool} doUpdate - False when thickening update triggered by scale or unit change.
   */
  PrintController3D.prototype.thickeningUpdated = function (active, doUpdate) {
    this.views.settings.updateScale();
    this.views.tools.setEnabled(
      sculpteo.PrintToolsView.TOOLS.THICKENING,
      active
    );

    if (doUpdate) {
      this.updatePriceForSelectedMaterial();
      this.updateMaterialList();
      this.views.series.reload();
    }
  };

  PrintController3D.prototype.switchTool = function (tool) {
    this.currentTool = tool;

    this.views.toolbar.hideHelpTool();

    //deactivate tool
    this.views.partOrientation.disabled();
    this.views.batchControl.disabled();
    this.views.hollowing.disabled();
    this.views.thickening.disabled();
    this.views.slicer.disabled();

    //reset available view in tool bar
    this.views.toolbar.resetViewAvailability();

    //set the tools on the left to the correct current tool
    this.views.tools.setActive(this.currentTool);

    this.views.viewer.viewerUI.viewer.updateSceneTransform();

    //this.setLoading(false);

    switch (this.currentTool) {
      case sculpteo.PrintToolsView.TOOLS.DASHBOARD:
        this.views.viewer.viewerUI.viewer.setQuality(2);
        this.views.viewer.viewerUI.viewer.setLocal(false);

        this.views.toolbar.changeView(sculpteo.PrintToolbarView.VIEWS.DEFAULT);

        //make the settings and price visible
        //this.toggleSettingsVisibility(true);
        this.setLoading(false);

        //show overlay message
        this.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.DASHBOARD,
          gettext("Mode : Dashboard"),
          false
        );
        break;
      case sculpteo.PrintToolsView.TOOLS.BATCH_CONTROL:
        //change the view with the default one
        this.views.toolbar.changeView(sculpteo.PrintToolbarView.VIEWS.DEFAULT);
        //make the set views unavailable
        this.views.toolbar.updateViewAvailability([
          sculpteo.PrintToolbarView.VIEWS.SOLIDITY_CHECK,
          sculpteo.PrintToolbarView.VIEWS.WIREFRAME,
          sculpteo.PrintToolbarView.VIEWS.CUTEWAY,
        ]);

        //active batchControl
        this.views.batchControl.enabled();

        //toggle the help modal on the current tool.
        //false mean that we don't show the modal if the user checked the check box previously
        this.toggleModalTool(false);

        //display a button in the tool bar help area
        //do the same as toggleModalTool
        this.views.toolbar.showHelpTool();

        //make the settings not visible
        this.toggleSettingsVisibility(false);

        //show overlay message
        this.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.BATCH_CONTROL,
          gettext("Mode : Batch control"),
          false
        );
        break;
      case sculpteo.PrintToolsView.TOOLS.ORIENTATION:
        this.views.toolbar.changeView(sculpteo.PrintToolbarView.VIEWS.DEFAULT);
        this.views.toolbar.updateViewAvailability([
          sculpteo.PrintToolbarView.VIEWS.SOLIDITY_CHECK,
          sculpteo.PrintToolbarView.VIEWS.WIREFRAME,
          sculpteo.PrintToolbarView.VIEWS.CUTEWAY,
        ]);

        this.views.partOrientation.enabled();

        this.toggleModalTool(false);
        this.views.toolbar.showHelpTool();

        this.toggleSettingsVisibility(false);

        //show overlay message
        this.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.ORIENTATION,
          gettext("Mode : Part orientation"),
          false
        );
        break;
      case sculpteo.PrintToolsView.TOOLS.HOLLOWING:
        this.views.toolbar.changeView(sculpteo.PrintToolbarView.VIEWS.DEFAULT);
        //this.views.toolbar.updateViewAvailability([sculpteo.PrintToolbarView.VIEWS.WIREFRAME]);

        this.views.hollowing.enabled();

        this.toggleModalTool(false);
        this.views.toolbar.showHelpTool();

        this.toggleSettingsVisibility(false);

        //show overlay message
        this.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.HOLLOWING,
          gettext("Mode : Hollowing"),
          false
        );
        break;
      case sculpteo.PrintToolsView.TOOLS.THICKENING:
        this.views.toolbar.changeView(
          sculpteo.PrintToolbarView.VIEWS.SOLIDITY_CHECK
        );
        this.views.thickening.enabled();

        this.toggleModalTool(false);
        this.views.toolbar.showHelpTool();

        this.toggleSettingsVisibility(false);

        //show overlay message
        this.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.THICKENING,
          gettext("Mode : Thickening"),
          false
        );
        break;
      case sculpteo.PrintToolsView.TOOLS.ANNOTATIONS:
        this.views.toolbar.changeView(sculpteo.PrintToolbarView.VIEWS.DEFAULT);
        //this.views.thickening.enabled();

        // this.toggleModalTool(false);
        // this.views.toolbar.showHelpTool();

        this.toggleSettingsVisibility(false);

        //show overlay message
        this.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.ANNOTATIONS,
          gettext("Mode : Annotations"),
          false
        );
        break;
      case sculpteo.PrintToolsView.TOOLS.SLICER:
        this.views.toolbar.changeView(sculpteo.PrintToolbarView.VIEWS.DEFAULT);

        //make the set views unavailable
        this.views.toolbar.updateViewAvailability([
          sculpteo.PrintToolbarView.VIEWS.SOLIDITY_CHECK,
          sculpteo.PrintToolbarView.VIEWS.WIREFRAME,
          sculpteo.PrintToolbarView.VIEWS.CUTEWAY,
        ]);

        this.views.slicer.enabled();

        // this.toggleModalTool(false);
        // this.views.toolbar.showHelpTool();

        this.toggleSettingsVisibility(false);

        //show overlay message
        this.overlayNotify(
          sculpteo.PrintOverlayNotification.TYPE.SLICER,
          gettext("Mode : Slicer"),
          false
        );
        break;
    }
  };

  /**
   * update the availability of each tools and reset it if there is not available
   *
   * @public
   */
  PrintController3D.prototype.updateToolsAvailability = function () {
    //if the model is NOT orderable we do not make any tools available
    if (this.design.is_orderable == false) {
      return;
    }

    var currentMaterialMap = this.materials.getCurrentMaterialMap();

    //test ORIENTATION
    if (
      sculpteo.TOOL_AVAILABLE_MAP.ORIENTATION.test(currentMaterialMap) ||
      (window.isStaff &&
        sculpteo.TOOL_AVAILABLE_MAP.ORIENTATION_STAFF_ONLY.test(
          currentMaterialMap
        ))
    ) {
      this.views.batchControl.togglePartOrientationViewButton(true);
      this.views.tools.toggle(sculpteo.PrintToolsView.TOOLS.ORIENTATION, true);
    } else {
      this.views.partOrientation.reset();
      this.views.batchControl.togglePartOrientationViewButton(false);
      this.views.tools.toggle(sculpteo.PrintToolsView.TOOLS.ORIENTATION, false);
    }

    // test BATCH_CONTROL
    // batch control is check in PrintBatchControlView.
    // TODO might be good to put the code here...
    // if (sculpteo.TOOL_AVAILABLE_MAP.BATCH_CONTROL.test(currentMaterialMap)) {
    //    console.log("BATCH_CONTROL available");
    // } else {
    //    console.log("BATCH_CONTROL NOT available");
    // }

    //test HOLLOWING
    if (
      !this.design.is_medical &&
      sculpteo.TOOL_AVAILABLE_MAP.HOLLOWING.test(currentMaterialMap)
    ) {
      this.views.tools.toggle(sculpteo.PrintToolsView.TOOLS.HOLLOWING, true);
    } else {
      this.views.tools.toggle(sculpteo.PrintToolsView.TOOLS.HOLLOWING, false);
      this.views.hollowing.reset();
    }

    //test THICKENING
    if (
      !this.design.is_medical &&
      sculpteo.TOOL_AVAILABLE_MAP.THICKENING.test(currentMaterialMap)
    ) {
      this.views.tools.toggle(sculpteo.PrintToolsView.TOOLS.THICKENING, true);
    } else {
      this.views.tools.toggle(sculpteo.PrintToolsView.TOOLS.THICKENING, false);
      this.views.thickening.reset();
    }

    //test SLICER
    if (sculpteo.TOOL_AVAILABLE_MAP.SLICER.test(currentMaterialMap)) {
      this.views.tools.toggle(sculpteo.PrintToolsView.TOOLS.SLICER, true);
    } else {
      this.views.tools.toggle(sculpteo.PrintToolsView.TOOLS.SLICER, false);
    }
  };

  /**
   * Reset the following settings & updates the printing operation
   * - material, finish, painting
   * - scale & unit
   */
  PrintController3D.prototype.reset = function () {
    this.setLoading(true);

    this.overlayNotify(
      sculpteo.PrintOverlayNotification.TYPE.RESET,
      gettext("Reset 3D settings, scale and tools"),
      false
    );

    this.design.dfd_fetch_operation = undefined;
    this.design.model_uuid = undefined;
    this.design.fetch_operation(true, false).done(
      function (response) {
        // Updating stored data
        this.design.material =
          window.materials[this.design.print_operation.data.o_product];
        this.design.finish = null;
        this.design.painting = null;
        this.design.order.finish = null;
        this.design.order.painting = null;
        this.design.order.options = null;
        this.design.options = null;
        this.design.size.userScale = this.design.print_operation.data.scale;
        this.design.size.unit = this.design.print_operation.data.unit;
        this.updateDetails();

        // Updating views
        this.views.settings.updateScale();
        this.views.settings.updateUnit();
        this.views.settings.updateSelectors();
        this.views.materials.updateSelectors();

        //we need to call batchcontrol first
        //if we are in batch, then we update the job in batchcontrol.updateBatchControl
        //Then we call updatePriceForSelectedMaterial
        //otherwise if we're not in batch the function updatebatchControl will resolve the promise directly
        //then we call updatePriceForSelectedMaterial
        this.views.batchControl.updateBatchControl().done(
          function (update) {
            this.updatePriceForSelectedMaterial();
            this.views.series.reload();
          }.bind(this)
        );

        this.updateMaterialList();

        this.updateToolsAvailability();

        //go to the top of the page when we reset
        this.views.viewer.scrollTop();
      }.bind(this)
    );
  };

  /**
   * handles loading. Hide/show price and setting
   *
   * @public
   * boolean
   */
  PrintController3D.prototype.setLoading = function (status, message) {
    this.views.price.enabled(!status);
    this.views.settings.enabled(!status);
    this.views.materials.enabled(!status);
  };

  PrintController3D.prototype.updateSelectors = function (quantity) {
    var deferred = $.Deferred();
    if (
      this.materials.pricesAndDefaultQuantitiesForAllMaterials.prices.hasOwnProperty(
        quantity
      )
    ) {
      this.views.settings.updateSelectors();
    } else {
      this.materials.is_fetching_all_materials = true;
      this.materials.computePricesAndDelays(false).then(
        function () {
          this.materials.is_fetching_all_materials = false;
          this.views.settings.updateSelectors();
          deferred.resolve();
        }.bind(this)
      );
    }
    return deferred;
  };
})((window.sculpteo = window.sculpteo || {}));
